import SitesPopover from "../components/UI/Popovers/SitesPopover/SitesPopover";
import { MenuItemEntity } from "../entities/UIEntities/MenuItem"; 
import CustomMenu from "../components/UI/Menus/CustomMenu/CustomMenu"; 
import Icons from "../resources/icons/Icons";
import { MENU_ITEMS, DAYS } from "../enums/Enums";
import {
  convertCurrencyToSymbol,
  getAmPmTimeFormatFromTimeString,
  timeStringToMins,
  minutesToString
} from "./CommonUtils";

import { handleEditBillingRule, handleEditEvRule, handleDeleteBillingRule } from "./MenuUtils";
import { isValidDate } from './FormUtils';

export const getBillingParkingLocation = (params) => {
  const site = params?.row?.site;
  return <SitesPopover sites={[site]}></SitesPopover>;
};

export const getBillingAssignedUserTypesString = (row) => {
  const userTypes = row?.billingRuleToUserTypes;
  const userTypeString = userTypes.reduce(
    (t1, t2) => t1 + `${t2?.userType?.type}, `,
    ""
  );
  const fixUserTypes = userTypeString?.slice(0, userTypeString.length - 2);

  return fixUserTypes;
};

export const getBillingRateString = (row) => {
  const siteCurrency = row?.site.billingCurrency;
  const siteCurrencySymbol = convertCurrencyToSymbol(siteCurrency);
  const rate =
    row?.billingRuleRates.length > 0
      ? `${row?.billingRuleRates[0]?.rateAmount} ${siteCurrencySymbol}`
      : "No rate";

  return rate;
};

export const getEvRuleMenuItem = (props) => {
  const menuItems = [
    new MenuItemEntity(
      MENU_ITEMS.EDIT,
      handleEditEvRule,
      true,
      Icons.EDIT_ITEM,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.DELETE,
      handleDeleteBillingRule,
      true,
      Icons.DELETE_ITEM,
      false,
      props
    )
  ];
    return <CustomMenu menuItems={menuItems}></CustomMenu>
};

export const getBillingMenuItem = (props) => {
  const menuItems = [
    new MenuItemEntity(
      MENU_ITEMS.EDIT,
      handleEditBillingRule,
      true,
      Icons.EDIT_ITEM,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.DELETE,
      handleDeleteBillingRule,
      true,
      Icons.DELETE_ITEM,
      false,
      props
    )
  ];
    return <CustomMenu menuItems={menuItems}></CustomMenu>
};

export const getBillingValidHoursString = (row) => {
  const startTime = getAmPmTimeFormatFromTimeString(row?.startTime);
  const endTime = getAmPmTimeFormatFromTimeString(row?.endTime);
  const validHour = `${startTime} - ${endTime}`;

  return validHour;
};

export const getStartTimeFromDate = (startTime) => {
  let dateTimeAsStr = startTime?.toLocaleTimeString('en-US', { hour12: false  });
  if(dateTimeAsStr && dateTimeAsStr === "24:00:00"){
    dateTimeAsStr = "00:00:00"
  }
  return dateTimeAsStr
}

export const isStartTimeBigger = (startTime, endTime) => {
  let res = false;
  if(startTime){
    if(endTime){
      if(startTime > endTime){
        res = true;
      }else{
        res = false;
      }
    }else{
      res = true;
    }
  }
  return res;
}

// can accept both date instance or string
export const isMidnightToMidnight = (startTime, endTime) => {
  // check if convertion from date to string is needed
  if (startTime !== undefined && endTime !== undefined) {
    if (startTime instanceof Date) {
      startTime = startTime.toLocaleTimeString('en-US', { hour12: false  });
    }
    if (endTime instanceof Date) {
      endTime = endTime.toLocaleTimeString('en-US', { hour12: false  });
    }
  
    if (startTime === '00:00:00' && endTime === '00:00:00') {
      return true;
    }
  }

  return false;
};

//compares the rule duration with rates and returns the difference in totalMinutes
export const getRuleDurationComparisonWithRates = (startTime, endTime, rates, isFullDay = false) => {
    if (!isValidDate(startTime) || !isValidDate(endTime)) {
      return 0;
    }

    startTime = getStartTimeFromDate(startTime);
    endTime = isFullDay ? "24:00:00" : endTime.toLocaleTimeString('en-US', { hour12: false  }); // converts dateTime to timeString with 24 hours format
    let ruleDuration = minutesToString( timeStringToMins(endTime) - timeStringToMins(startTime));
    let hours = parseInt(ruleDuration.split(':')[0]);
    let minutes = parseInt(ruleDuration.split(':')[1]);
    let totalDurationMinutes = hours * 60 + minutes;

    // Handle rates 
    let ratesTotalMinutes = 0;
    let ratesTotalHours = 0; 
    let ratesTotalDurationInMinutes = 0;

    // if rates not empty check with given rates for comaprison
    if (rates?.length !== 0) {
      rates.forEach(r => {
        if (r.chargeBy === "Hours" ) {
          ratesTotalHours += r.duration * r.period;
        } else if (r.chargeBy === "Minutes") {
          ratesTotalMinutes += r.duration * r.period;
        }
      });

      ratesTotalDurationInMinutes = ratesTotalHours * 60 + ratesTotalMinutes;
    }

    totalDurationMinutes = totalDurationMinutes - ratesTotalDurationInMinutes;

    return totalDurationMinutes;
};

export const getCalculateDays = (days) => {
  days = days.map(day => {
    return DAYS[day.toString()]?.value;
  });

  return days.reduce((v1, v2) => v1 + v2);
};

export const getDaysSelectionArrayFromDaysInt = (daysAsInt) => {
  let daysSelectionArr = []
  let daysAsBinaryString = daysAsInt.toString(2);
  daysAsBinaryString =
    "0000000".substring(daysAsBinaryString.length) + daysAsBinaryString;
  daysAsBinaryString = daysAsBinaryString.split("").reverse().join("");

  for (let i = 1; i < daysAsBinaryString.length; i++) {
     let dayValue = Math.pow(2, i);
     for(var idx in DAYS){
       if(DAYS[idx].value === dayValue && daysAsBinaryString[i] !== "0"){
         daysSelectionArr.push(idx);
           break; // If you want to break out of the loop once you've found a match
      }
    }  
  }

  return daysSelectionArr;
};

export const getDaysAsStringFromDaysInt = (row) => {
  const daysAsInt = row?.days;
  let daysAsBinaryString = daysAsInt.toString(2);
  daysAsBinaryString =
    "0000000".substring(daysAsBinaryString.length) + daysAsBinaryString;
  daysAsBinaryString = daysAsBinaryString.split("").reverse().join("");
  let daysAsString = [];
  let start = "";
  let end = "";
  for (let i = 1; i < daysAsBinaryString.length; i++) {
    let dayValue = Math.pow(2, i);
    let val;
    for(var idx in DAYS){
      if(DAYS[idx].value === dayValue){
          // Add an element to the dictionary
          val = idx;
          break; // If you want to break out of the loop once you've found a match
      }
    }

    if (daysAsBinaryString[i] !== "0") {
      if (!start) {
        start = DAYS[val].name;
      } else {
        end = DAYS[val].name;
      }
    } else {
      if (end && start) {
        daysAsString.push(`${start}-${end}`);
        start = "";
        end = "";
      } else if (start && !end) {
        daysAsString.push(`${start}`);
        start = "";
        end = "";
      }
    }
    if (start && i === daysAsBinaryString.length - 1) {
      if (start !== DAYS[val].name) {
        daysAsString.push(`${start}-${DAYS[val].name}`);
      } else {
        daysAsString.push(`${start}`);
      }
    }
  }

  return daysAsString;
};

export const getDaysDivFromDaysStringArray = (params) => {
  let daysAsString = params.row?.validDays;
  return (
    <div>
      {daysAsString.map((day, index) => {
        return <div key={index}>{day}</div>;
      })}
    </div>
  );
};

export const getSortedRates = (rates) => {
  let newRates = [];
  if (rates) {
    let copyRates = [...rates]
    newRates = copyRates.sort((rate1, rate2) => rate1.rateIndex - rate2.rateIndex)
  }

  return newRates;
}